module.exports = __webpack_public_path__ + "img/Play-Exchange-Icons.ad1f126.svg";